import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
const parse  = require('url-parse');
import App from './App';
import configureStore from './store';
import {fetchRow,fetchNewRow} from './store/actions';
import 'whatwg-fetch';
import './index.css';
// import registerServiceWorker from './registerServiceWorker';
import {unregister}  from './registerServiceWorker';

const parsedUrl = parse(window.location.href,true);
const apiUrl = parsedUrl.origin + "/api";
const store = configureStore(apiUrl);

ReactDOM.render(
	<Provider store={store}>
		<App />
	</Provider>,
	document.getElementById('root') as HTMLElement
);

// http://localhost:8181/9af74ca47285aa409bd6f9c1a3852416
store.dispatch(parsedUrl.query.n ? fetchNewRow(parsedUrl.query.b_o ? parsedUrl.query.b_o : 'ttc', parsedUrl.query.t) : fetchRow(parsedUrl.query.b_o ? parsedUrl.query.b_o : 'ttc', parsedUrl.query.t || "47eee4a6370c18949f9e025ec8df9d0c"));

// note register again when server routing will be stablized (disabled for now because of cache problems)
unregister();
// registerServiceWorker();




// WEBPACK FOOTER //
// ./src/index.tsx